import { useCallback, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { SESSION_UPDATED_EVENT } from '../services/authSession';
import { getMarketingAuthState } from '../services/marketingAuth';

export function useMarketingAuth() {
    const location = useLocation();
    const [authState, setAuthState] = useState(getMarketingAuthState);

    const refresh = useCallback(() => {
        setAuthState(getMarketingAuthState());
    }, []);

    useEffect(() => {
        refresh();
    }, [location.pathname, refresh]);

    useEffect(() => {
        window.addEventListener(SESSION_UPDATED_EVENT, refresh);
        window.addEventListener('storage', refresh);
        return () => {
            window.removeEventListener(SESSION_UPDATED_EVENT, refresh);
            window.removeEventListener('storage', refresh);
        };
    }, [refresh]);

    return authState;
}
